import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20illustration%20with%20soft%20flowing%20shapes%2C%20warm%20coral%20and%20amber%20gradients%2C%20modern%20minimalist%20composition%2C%20subtle%20texture%2C%20clean%20background%2C%20digital%20art%20style%2C%20atmospheric%20light%2C%20no%20text%2C%20abstract%20forms&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
          {t('hero.title')}
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta')}
          </Link>
          <div className="relative w-full sm:w-72">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-foreground-400 text-sm"></i>
              </div>
            </div>
            <input
              type="text"
              placeholder={t('hero.search')}
              className="w-full pl-10 pr-4 py-3 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full text-sm text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-all duration-300"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-8 h-8 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}